import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context) {
	var base = '.b-goodSlider';

	$(base, context).each(function(i, el){
		var $el = $(el);

		var productThumbs = new Swiper(el.querySelector('.b-goodSlider-thumbs'), {
			spaceBetween: 10,
			slidesPerView: 3,
			touchRatio: 0.2,
			slideToClickedSlide: true,
			watchOverflow: true,
			direction: 'horizontal',
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			breakpoints: {
				576: {
					direction: 'horizontal',
					slidesPerView: 4,
					spaceBetween: 10,
				},
				768: {
					direction: 'vertical',
					slidesPerView: 4,
					spaceBetween: 20,
				}
			},
		});

		var productSlider = new Swiper(el.querySelector('.b-goodSlider-slider'), {
			spaceBetween: 8,
			navigation: {
				nextEl: el.querySelectorAll('.b-goodSlider-next'),
				prevEl: el.querySelectorAll('.b-goodSlider-prev'),
			},
			pagination : {
				el : el.querySelector('.swiper-pagination'),
				clickable: true,
			},
			thumbs: {
				swiper: productThumbs
			},
			breakpoints: {
				768: {
					pagination: false,
				}
			},
		});

		$el.data('goodSlider', productSlider);

		var slides = $el.find('.b-goodSlider-thumbs .swiper-wrapper .swiper-slide');
		var arrowPrev = $el.find('.b-goodSlider-navInner .b-goodSlider-prev');
		var arrowNext = $el.find('.b-goodSlider-navInner .b-goodSlider-next');


		if (slides.length <= 6) {
			arrowPrev.prop('hidden', true);
			arrowNext.prop('hidden', true);
		}
	});
});